import React from 'react';
import {
  basePatchQuery,
  uploadSingleImage,
} from '../../../../utility/sb-api/sb-api.service';
import {
  closeModalSafely as closeModalSafelyBase,
  getTranslationsCollapsable as getTranslationsCollapsableBase,
  getServiceTimesCollapsable as getServiceTimesCollapsableBase,
  getOrderConditionsCollapsable as getOrderConditionsCollapsableBase,
  handleSubmit as handleSubmitBase,
} from '../modals.service';

export const closeModalSafely = closeModalSafelyBase;

export const handleSubmit = (
  event,
  errors,
  values,
  uploadImage,
  targetItemData,
  isEditMode,
  isVariation,
  setIsSubmitting,
  setTargetItemData,
  closeModal,
  onSubmit,
  orderConditions,
  newOrderCondition,
  isAddOrderConditionOpen,
  storeId,
) => {
  if (!errors?.length > 0) {
    setIsSubmitting(true);

    let imageIdPromise;

    if (uploadImage) {
      imageIdPromise = uploadSingleImage(uploadImage, storeId).then(
        (res) => res.id,
      );
    } else {
      const targetImageData = targetItemData?.image;
      const imageId = targetImageData?.id || null;
      imageIdPromise = Promise.resolve(imageId);
    }

    imageIdPromise.then((imageId) => {
      const preparedValues = {
        ...values,
        imageId: imageId,
        smartSchankPlu: values?.smartSchankPlu || null,
      };
      return isVariation
        ? handleSubmitBase(
            'item-data/food',
            'editItemVariationSuccess',
            'editItemVariationError',
            'createNewItemVariationSuccess',
            'createNewItemVariationError',
            event,
            errors,
            preparedValues,
            {
              ...targetItemData,
              ingredients: undefined,
              preferences: undefined,
              allergens: undefined,
              additions: undefined,
              image: undefined,
              additionGroups: undefined,
              orderConditions: isAddOrderConditionOpen
                ? [...(orderConditions || []), newOrderCondition]
                : orderConditions,
            },
            isEditMode,
            setIsSubmitting,
            setTargetItemData,
            closeModal,
            onSubmit,
            storeId,
          )
        : // this is only used when creating an FoodItem. The FoodItemData is passed through data prop.
          handleSubmitBase(
            'items/food',
            'editItemSuccess',
            'editItemError',
            'createNewItemSuccess',
            'createNewItemError',
            event,
            errors,
            {
              categoryIds: values.categoryIds || null,
              data: {
                ...targetItemData,
                ...preparedValues,
                additionGroups: undefined,
                orderConditions: isAddOrderConditionOpen
                  ? [...(orderConditions || []), newOrderCondition]
                  : orderConditions,
                ingredients: undefined,
                preferences: undefined,
                allergens: undefined,
                additions: undefined,
                categoryIds: undefined,
                manualRanking: preparedValues?.manualRanking
                  ? parseInt(preparedValues.manualRanking)
                  : undefined,
              },
            },
            {},
            isEditMode,
            setIsSubmitting,
            setTargetItemData,
            closeModal,
            onSubmit,
            storeId,
          );
    });
  } else {
    console.error('Got validation errors in ' + errors.join(', '));
  }
};

export const getTranslationsCollapsable = getTranslationsCollapsableBase;
export const getServiceTimesCollapsable = getServiceTimesCollapsableBase;
export const getOrderConditionsCollapsable = getOrderConditionsCollapsableBase;
